module.exports = __webpack_public_path__ + "img/ring_y_o_0_0@3x.8c2b0f13.png";